import { skipToken } from '@reduxjs/toolkit/query';
import { useGetAnimalFieldVisibilityQuery } from 'redux/apiSlice/tenant.slices';
import { EAnimalInfoConfig } from 'data/types/animalFieldVisibility.types';

// What the resident's property config set hides from them during the application flow. Three
// surfaces ask the same question, so the query, the predicate and the fail-open reading live here
// rather than being copied at each one.
//
// `skipToken` rather than a `skip` flag plus a cast: with no residency there is no config set to
// resolve, and skipToken is what lets the argument stay typed instead of laundering `undefined`
// past a required param.
//
// Fail-open on purpose. An absent or failed response reads as "nothing hidden", which is the
// pre-feature behaviour — a resident is never shown less than they can complete. `isLoading` is
// returned separately because loading is not the same as "nothing hidden": a caller that paints
// during it shows the hidden fields for a frame and then removes them.
const useAnimalFieldVisibility = (tenantResidencyId?: string | null) => {
  const { data, isLoading } = useGetAnimalFieldVisibilityQuery(
    tenantResidencyId ? { tenantResidencyId } : skipToken,
  );

  return {
    isHidden: (criterion: EAnimalInfoConfig) =>
      !!data?.hiddenRequirements.includes(criterion),
    hideDocumentsSection: !!data?.hideDocumentsSection,
    isLoading,
  };
};

export default useAnimalFieldVisibility;
